import { createFileRoute } from "@tanstack/react-router";
import { permissionMatrixSearchSchema } from "@/lib/search/permission-matrix-search";

const WorkspaceSettingsProjecthoursRoute = (): null => null;

export const Route = createFileRoute("/_app/settings/workspace/projecthours/")({
	validateSearch: permissionMatrixSearchSchema,
	component: WorkspaceSettingsProjecthoursRoute,
});
